import $ from 'jquery';
import { isTouch } from '../utils/inspection';
import { onResize } from '../utils/window';

/**
 * Staff Portal functionality enhancements.
 *
 * @param context
 */
export default function staffPortalPage(context=document.body) {
    const $context = $(context);

    if (!isTouch()) {
        const $staffPortal = $context.find('.staff-portal');
        const $sideMenu = $staffPortal.find('.side-menu');

        onResize(() => {
            const sideMenuHeight = $sideMenu.outerHeight();
            const staffPortalHeight = $staffPortal.outerHeight();

            if (staffPortalHeight <= sideMenuHeight) {
                $staffPortal.css('height', `${sideMenuHeight}px`);
            } else {
                $staffPortal.css('height', '');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/pages/staff-portal.js